import { Module } from '../../ts/Module';

// This is patterned after ngMouseDown,
// with the addition of the check for tb-disabled.
Module.instance().directive('tbButtonDown', <any[]>[
  '$parse',
  ($parse: ng.IParseService) => {
    return {
      restrict: 'A',
      link: (scope: ng.IScope, element: JQuery, attr: ng.IAttributes) => {
        const downFn = $parse(attr['tbButtonDown']);
        element.on('mousedown', (event: JQuery.Event) => {
          scope.$apply(() => {
            if (!element.hasClass('tb-disabled')) {
              downFn(scope, {$event: event});
            }
          });
        });
      }
    };
  }
]);
